import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { DataTable, Badge } from "@/components/common/DataTable";

export default function AuditPage() {
  const [data, setData] = useState({ items: [], total: 0 });
  const [filters, setFilters] = useState({ entityType: "", action: "" });
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const params = new URLSearchParams();
    if (filters.entityType) params.set("entityType", filters.entityType);
    if (filters.action) params.set("action", filters.action);
    params.set("size", "100");
    try { setData((await api.get(`/v1/audit?${params}`)).data.data); }
    finally { setLoading(false); }
  }, [filters]);
  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="audit-page">
      <PageHeader title="Audit Center" subtitle={`Immutable activity trail · ${data.total} records`} />
      <div className="flex flex-wrap gap-3 mb-4">
        <input placeholder="Entity type (e.g. TENANT)" value={filters.entityType} onChange={(e) => setFilters({ ...filters, entityType: e.target.value.toUpperCase() })} className="rounded-lg border border-slate-300 px-3 py-2 text-sm" data-testid="audit-filter-entity" />
        <input placeholder="Action (e.g. CREATE)" value={filters.action} onChange={(e) => setFilters({ ...filters, action: e.target.value.toUpperCase() })} className="rounded-lg border border-slate-300 px-3 py-2 text-sm" data-testid="audit-filter-action" />
      </div>
      <DataTable testid="audit-table" rows={data.items} loading={loading}
        columns={[
          { key: "timestamp", header: "Time", render: (a) => (a.timestamp || "").slice(0, 19).replace("T", " ") },
          { key: "entityType", header: "Entity", render: (a) => <Badge color="teal">{a.entityType}</Badge> },
          { key: "action", header: "Action" },
          { key: "actorEmail", header: "Actor", render: (a) => a.actorEmail || "—" },
          { key: "entityId", header: "Entity ID", render: (a) => a.entityId ? <span className="font-mono text-xs">{a.entityId.slice(0, 8)}</span> : "—" },
        ]} />
    </div>
  );
}
